import { IIncentiveParamsNumberOfEntriesFeePercentage } from "./incentive-params-number-of-entries-fee-percentage.interface";

export class IncentiveParamsNumberOfEntriesFeePercentageDto
  implements IIncentiveParamsNumberOfEntriesFeePercentage
{
  number_of_entries: number;
  fee_percentage: number;
}
